export default {
    invalidEmailFormat: 'Ungültiges E-Mail-Format',
    sendScreenshot: 'Screenshot senden',
    selectedTemplate: 'Ausgewähltes Template',
    createNew: 'Neues Template erstellen',
    selectExisting: 'Vorhandenes Template auswählen',
    templateName: 'Template Name',
    setUserIdAsReplyTo: 'Benutze User-Login als Reply-To Email-Adresse bei der verschickten E-Mail',
    LoginBlockEmailAdressHint: 'Stellen Sie sicher, dass beim Login-Block die Option angewählt ist, nur E-Mails als Input zuzulassen.',
    invalidEmailAddress: 'Ungültige E-Mail-Adresse',
}